module.exports = __webpack_public_path__ + "static/media/cross.74a26e3f.svg";